import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-ContentLocalitySearch" */'@modals/partials/ContentLocalitySearch'));
